// Polyfills
import '@babel/polyfill';
import 'url-polyfill';
import 'isomorphic-fetch';
import 'custom-event-polyfill';
import 'blueimp-canvas-to-blob';
import 'intersection-observer';

// Library CSS
import 'cropperjs/dist/cropper.css';
import 'flatpickr/dist/flatpickr.css';
import 'draft-js/dist/Draft.css';
import 'draft-js-static-toolbar-plugin/lib/plugin.css';
import 'video.js/dist/video-js.css';

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'startup/App';

ReactDOM.render(<App />, document.getElementById('root'));
